import React from 'react';
import axios from 'axios';


function LeadInfo(WrappedComponent) {

    return class extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                client_name: ''
            };
            this.extractName = this.extractName.bind(this)
        }

        extractName(name, position) {
            const words = name.split(' ');
            let result;
            const exceptions = ['del', 'de']

            if (position === 'start') {
                result = words[0];
            } else if (position === 'end') {
                const lastTwoWords = words.slice(-2);
                const penultimateWord = lastTwoWords[0];
                const lastWord = lastTwoWords[1];

                if (exceptions.includes(penultimateWord)) {
                    result = lastWord;
                } else {
                    result = lastTwoWords.join(" ");
                }
            }

            return result;
        }


        async componentDidMount() {
            try {
                let sanitizedName = localStorage.getItem('sanitizedName');

                if (sanitizedName === null) {
                    const formName = localStorage.getItem('formName');

                    if (formName) {
                        sanitizedName = this.extractName(formName, 'start')
                    } else {
                        let apiName

                        const ROOT_URL = process.env.API_URL;
                        var config = {
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                            }
                        };
                        const response = await axios.get(`${ROOT_URL}/leads/details`, config)

                        apiName = response.data['name']
                        sanitizedName = this.extractName(apiName, 'end')
                    }
                    localStorage.setItem('sanitizedName', sanitizedName)
                }
                this.setState({
                    client_name: sanitizedName,
                });
            }
            catch (error) {
                this.setState({
                    client_name: 'Cliente',
                });
            }

        }

        render() {
            return <WrappedComponent {...this.props} clientName={this.state.client_name} />;
        }
    };
}

export default LeadInfo;


/** WEBPACK FOOTER **
 ** ./src/components/LeadInfo.js
 **/